import { Config } from '../config';
import { UserService } from './User';

export const DocumentService = {
  /**
    * [LIST]
    */
  List() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return DocumentService.Common.Fetch(Config.service.document.list, requestOptions);
  },
  /**
    * [DETAIL]
    * @param {string} login
    */
  Detail(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return DocumentService.Common.Fetch(Config.service.document.detail, requestOptions);
  },
  /**
    * [ACTION]
    * @param {string} login
    * @param {string} approve
    */
  Action(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return DocumentService.Common.Fetch(Config.service.document.action, requestOptions);
  },
  /**
 * [COMMON]
 * @function Fetch
 */
  Common: {
    Fetch(url, requestOptions) {
      return fetch(url, requestOptions)
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          if (response.status === 401) {
            UserService.Logout();
            window.location.reload();
          } else {
            throw new Error();
          }
          return false;
        })
        .then(json => json)
        .catch(() => false);
    },
  },
};
